<template>
    <AButton :type="type" :size="size" :icon="icon" @click="backMainPage">{{btnText}}</AButton>
</template>
<script>
import {
    mapMutations
} from 'vuex'
export default {
    props: {
        /** 按钮文本 */
        btnText: {
            type: String,
            default: '返回主页'
        },
        type: {
            default: 'green'
        },
        icon:{
            default:"left"
        },
        size:{
            default:"large"
        }
    },
    methods: {
        ...mapMutations(['setCollapsed']),
        backMainPage() {
            this.setCollapsed(false)
        }
    },
}
</script>

<style lang='less' scoped></style>